/**
 * El «ding» de los avisos.
 *
 * Un solo elemento de audio reutilizado: crear uno por aviso acumula
 * decodificaciones y en ráfaga suena a cacofonía. El navegador bloquea el
 * audio hasta la primera interacción con la página; si todavía no la hubo,
 * el aviso queda en lo visual y no pasa nada — por eso el catch vacío.
 */
let audio: HTMLAudioElement | null = null;

export function sonarAviso(): void {
  try {
    audio ??= new Audio('/sonidos/aviso.wav');
    audio.currentTime = 0;
    void audio.play().catch(() => {});
  } catch {
    // Sin soporte de audio, el aviso visual basta.
  }
}
